import type { ENUM_DELIVERYMAN_STATUS } from '@/_constants/enums';

interface Localization {
  type: string;
  coordinates: number[];
}

export enum DELIVERY_MODEL_TYPE {
  CLOUD = 'CLOUD',
  LINKED = 'LINKED',
  CLOUD_AND_LINKED = 'LINKED_AND_CLOUD',
}

export interface OnlineDeliveryman {
  _id: string;
  status: ENUM_DELIVERYMAN_STATUS;
  localization: Localization;
  deliverymanName: string;
  lastDelivery?: Date;
  deliverymanType: DELIVERY_MODEL_TYPE;
}

export interface DeliverymanNumbers {
  total: number;
  online: number;
  available: number;
  offline: number;
  inDelivery: number;
}

export interface DeliverymanInfos {
  total: number;
  online: number;
  available: number;
  offline: number;
  inDelivery: number;
  ownDeliveryman: DeliverymanNumbers;
  cloudDeliveryman: DeliverymanNumbers;
  ownAndCloudDeliveryman: DeliverymanNumbers;
}

export interface PlacesWithLocation {
  _id: string;
  inProgressDeliveriesCount: number;
  placeName: string;
  pendingDeliveriesCount: number;
  localization?: Localization;
  placeType: DELIVERY_MODEL_TYPE;
}

export interface PlaceNumbers {
  closed: number;
  open: number;
  total: number;
  totalPlacesWithInProgressDeliveries: number;
  totalPlacesWithPendingDeliveries: number;
  totalInProgressOrders: number;
  totalPlacesWithInProgressOrders: number;
}

export interface PlacesInfos {
  closed: number;
  open: number;
  total: number;
  totalPlacesWithInProgressDeliveries: number;
  totalPlacesWithPendingDeliveries: number;
  totalInProgressOrders: number;
  totalPlacesWithInProgressOrders: number;
  ownPlaces: PlaceNumbers;
  cloudPlaces: PlaceNumbers;
  ownAndCloudPlaces: PlaceNumbers;
}

export interface DashboardInfos {
  deliverymenInfo: DeliverymanInfos;
  onlineDeliverymen: OnlineDeliveryman[];
  placesInfos: PlacesInfos;
  placesWithLocation: PlacesWithLocation[];
}

export interface PlacesInfosDashboardModalProps {
  avatarSrc: string;
  placeName: string;
  maxDistaceRadius: number;
  maxDistanceDropsToGroup: number;
  maxQuantityDeliveryGroup: number;
  hasOnlyDeliverymenDedicated: boolean;
  deliverymenAvailable: { _id: string; nome: string }[];
}

export interface PlacesOpen {
  _id: string;
  avatarSrc: string;
  placeName: string;
  deliveriesQuantity: number;
  logDeliveriesQuantity: number;
  deliverymenAvailableQuantity: number;
}
